export let FluidElementType = /*#__PURE__*/function (FluidElementType) {
  FluidElementType["Text"] = "Text";
  FluidElementType["Heading"] = "Heading";
  FluidElementType["Button"] = "Button";
  FluidElementType["Image"] = "Image";
  FluidElementType["AppStoreButton"] = "AppStoreButton";
  FluidElementType["SocialLinks"] = "SocialLinks";
  FluidElementType["Form"] = "Form";
  FluidElementType["Video"] = "Video";
  FluidElementType["Counter"] = "Counter";
  FluidElementType["Embed"] = "Embed";
  FluidElementType["Map"] = "Map";
  return FluidElementType;
}({});
export let StickyScrollPosition = /*#__PURE__*/function (StickyScrollPosition) {
  StickyScrollPosition["Top"] = "top";
  StickyScrollPosition["Center"] = "center";
  StickyScrollPosition["Bottom"] = "bottom";
  return StickyScrollPosition;
}({});
export let AlignmentValue = /*#__PURE__*/function (AlignmentValue) {
  AlignmentValue["Start"] = "start";
  AlignmentValue["Center"] = "center";
  AlignmentValue["End"] = "end";
  return AlignmentValue;
}({});
export let PaddingValue = /*#__PURE__*/function (PaddingValue) {
  PaddingValue[PaddingValue["None"] = 0] = "None";
  PaddingValue[PaddingValue["Small"] = 20] = "Small";
  PaddingValue[PaddingValue["Medium"] = 40] = "Medium";
  PaddingValue[PaddingValue["Large"] = 60] = "Large";
  return PaddingValue;
}({});
export let BackgroundType = /*#__PURE__*/function (BackgroundType) {
  BackgroundType["Color"] = "Color";
  BackgroundType["Image"] = "Image";
  BackgroundType["Video"] = "Video";
  return BackgroundType;
}({});
export let ColorType = /*#__PURE__*/function (ColorType) {
  ColorType["Theme"] = "Theme";
  ColorType["Custom"] = "Custom";
  ColorType["Gradient"] = "Gradient";
  return ColorType;
}({});

// Not used
// export enum ImageObjectFit {
//   "None" = "None",
//   "Fill" = "Fill",
//   "Cover" = "Cover",
//   "Contain" = "Contain",
// }

export let BackgroundPosition = /*#__PURE__*/function (BackgroundPosition) {
  BackgroundPosition["LeftTop"] = "left top";
  BackgroundPosition["CenterTop"] = "center top";
  BackgroundPosition["RightTop"] = "right top";
  BackgroundPosition["LeftCenter"] = "left center";
  BackgroundPosition["CenterCenter"] = "center center";
  BackgroundPosition["RightCenter"] = "right center";
  BackgroundPosition["LeftBottom"] = "left bottom";
  BackgroundPosition["CenterBottom"] = "center bottom";
  BackgroundPosition["RightBottom"] = "right bottom";
  return BackgroundPosition;
}({});
export let BackgroundRepeat = /*#__PURE__*/function (BackgroundRepeat) {
  BackgroundRepeat["Repeat"] = "repeat";
  BackgroundRepeat["NoRepeat"] = "no-repeat";
  return BackgroundRepeat;
}({});
export let BackgroundScrollEffect = /*#__PURE__*/function (BackgroundScrollEffect) {
  BackgroundScrollEffect["Fixed"] = "fixed";
  BackgroundScrollEffect["Scroll"] = "scroll";
  return BackgroundScrollEffect;
}({});
export let ImageSize = /*#__PURE__*/function (ImageSize) {
  ImageSize["Cover"] = "cover";
  ImageSize["Contain"] = "contain";
  return ImageSize;
}({});
export let ThemeColorClass = /*#__PURE__*/function (ThemeColorClass) {
  ThemeColorClass["brand"] = "brand";
  ThemeColorClass["secondary"] = "secondary";
  ThemeColorClass["base"] = "base";
  ThemeColorClass["accent"] = "accent";
  return ThemeColorClass;
}({});
export let ThemeColor = /*#__PURE__*/function (ThemeColor) {
  ThemeColor["brand1"] = "brand1";
  ThemeColor["brand2"] = "brand2";
  ThemeColor["brand3"] = "brand3";
  ThemeColor["brand4"] = "brand4";
  ThemeColor["secondary1"] = "secondary1";
  ThemeColor["secondary2"] = "secondary2";
  ThemeColor["secondary3"] = "secondary3";
  ThemeColor["secondary4"] = "secondary4";
  ThemeColor["base1"] = "base1";
  ThemeColor["base2"] = "base2";
  ThemeColor["base3"] = "base3";
  ThemeColor["base4"] = "base4";
  ThemeColor["base5"] = "base5";
  ThemeColor["accent1"] = "accent1";
  ThemeColor["accent2"] = "accent2";
  ThemeColor["transparent"] = "transparent";
  return ThemeColor;
}({});
export let ColorValue = /*#__PURE__*/function (ColorValue) {
  ColorValue["brand1"] = "--theme-color-brand1";
  ColorValue["brand2"] = "--theme-color-brand2";
  ColorValue["brand3"] = "--theme-color-brand3";
  ColorValue["brand4"] = "--theme-color-brand4";
  ColorValue["secondary1"] = "--theme-color-secondary1";
  ColorValue["secondary2"] = "--theme-color-secondary2";
  ColorValue["secondary3"] = "--theme-color-secondary3";
  ColorValue["secondary4"] = "--theme-color-secondary4";
  ColorValue["base1"] = "--theme-color-base1";
  ColorValue["base2"] = "--theme-color-base2";
  ColorValue["base3"] = "--theme-color-base3";
  ColorValue["base4"] = "--theme-color-base4";
  ColorValue["base5"] = "--theme-color-base5";
  ColorValue["accent1"] = "--theme-color-accent1";
  ColorValue["accent2"] = "--theme-color-accent2";
  ColorValue["transparent"] = "--theme-transparent-color";
  return ColorValue;
}({});
export let Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["Mobile"] = "mobile";
  Breakpoint["Tablet"] = "tablet";
  Breakpoint["Desktop"] = "desktop";
  return Breakpoint;
}({});
export let Side = /*#__PURE__*/function (Side) {
  Side["Top"] = "top";
  Side["Right"] = "right";
  Side["Bottom"] = "bottom";
  Side["Left"] = "left";
  return Side;
}({});
export let GuideLinesType = /*#__PURE__*/function (GuideLinesType) {
  GuideLinesType["Grid"] = "grid";
  GuideLinesType["Element"] = "element";
  return GuideLinesType;
}({});
//# sourceMappingURL=enums.js.map